<template>
    <google-analytics-inertia/>
    <div class="w-100 h-full">
        <flash-messages/>
        <honeybadger-error-tracking/>
        <page-super-banner v-if="$page.props.site_config.global_super_banner">
            <span v-html="$page.props.site_config.global_super_banner"></span>
        </page-super-banner>
        <slot></slot>
    </div>
</template>

<script>

import GoogleAnalyticsInertia from '../Components/GoogleAnalyticsInertia.vue'
import FlashMessages from '../Components/FlashMessages.vue'
import HoneybadgerErrorTracking from '../Components/HoneybadgerErrorTracking.vue'
import PageSuperBanner from '../Components/PageSuperBanner.vue'

export default {
    name: 'FrontendFullscreenLayout',
    components: { PageSuperBanner, HoneybadgerErrorTracking, FlashMessages, GoogleAnalyticsInertia },
}
</script>
